export const categories = [
  { id: 'movie', name: '电影', slug: 'movie', icon: 'ri-film-line', color: 'primary' },
  { id: 'tv', name: '电视剧', slug: 'tv', icon: 'ri-tv-line', color: 'accent' },
  { id: 'variety', name: '综艺', slug: 'variety', icon: 'ri-music-2-line', color: 'secondary' },
  { id: 'anime', name: '动漫', slug: 'anime', icon: 'ri-rocket-line', color: 'primary' },
  { id: 'documentary', name: '纪录片', slug: 'documentary', icon: 'ri-earth-line', color: 'accent' },
  { id: 'short', name: '短剧', slug: 'short', icon: 'ri-smartphone-line', color: 'secondary' },
];

export const regions = [
  { id: 'china', name: '中国大陆', slug: 'china' },
  { id: 'hongkong', name: '中国香港', slug: 'hongkong' },
  { id: 'taiwan', name: '中国台湾', slug: 'taiwan' },
  { id: 'korea', name: '韩国', slug: 'korea' },
  { id: 'japan', name: '日本', slug: 'japan' },
  { id: 'america', name: '美国', slug: 'america' },
  { id: 'europe', name: '欧洲', slug: 'europe' },
  { id: 'other', name: '其他', slug: 'other' },
];

export const years = [
  { id: '2026', name: '2026年', slug: '2026' },
  { id: '2025', name: '2025年', slug: '2025' },
  { id: '2024', name: '2024年', slug: '2024' },
  { id: '2023', name: '2023年', slug: '2023' },
  { id: '2022', name: '2022年', slug: '2022' },
  { id: 'older', name: '更早', slug: 'older' },
];